import { MIXPANEL_NONE } from "@src/constants/analyticsTracking";

/**
 * Parses SuperAdmin Skill for Mixpanel.
 * Standalone lessons store Skill in `categories` JSON (`categories.Skill`),
 * not the top-level `skill` field. Units use `unit.skill`.
 */
export const resolveMixpanelSkill = ({
  categories,
  skill,
}: {
  categories?: string | null;
  skill?: string | null;
} = {}): string => {
  const fromField = (skill ?? "").trim();

  if (categories?.trim()) {
    try {
      const parsed = JSON.parse(categories);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        const fromCategories = String(parsed.Skill ?? "").trim();
        if (fromCategories) return fromCategories;
      }
    } catch {
      // ignore invalid categories JSON
    }
  }

  return fromField;
};

/** Always include skill — "None" when unknown (avoids Mixpanel "(not set)"). */
export const mixpanelSkillProps = (args?: {
  categories?: string | null;
  skill?: string | null;
}): { skill: string } => {
  return { skill: resolveMixpanelSkill(args) || MIXPANEL_NONE };
};
